function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import PropTypes from 'prop-types';
import ReactResizeDetector from 'react-resize-detector';
import componentPropType from '@signal/prop-types/component';
import renderIf from '@signal/utils/renderIf';
import isValidComponent from '@signal/utils/isValidComponent';
import Legend from '../Legend';
import StackedBarChart, { stackedBarChartSeriesPropType } from '../StackedBarChart';
import Typography from '../Typography';
import { Wrapper, ChartWrapper } from './styles';
export var StackedBarChartWithLegend = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(StackedBarChartWithLegend, _React$PureComponent);

  var _super = _createSuper(StackedBarChartWithLegend);

  function StackedBarChartWithLegend() {
    _classCallCheck(this, StackedBarChartWithLegend);

    return _super.apply(this, arguments);
  }

  _createClass(StackedBarChartWithLegend, [{
    key: "description",
    get: function get() {
      var _this$props = this.props,
          description = _this$props.description,
          descriptionProps = _this$props.descriptionProps;
      if (!description) return null;
      var DescriptionComponent = isValidComponent(description) && description;
      return DescriptionComponent || /*#__PURE__*/React.createElement(Typography, descriptionProps, description);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          series = _this$props2.series,
          hideLegend = _this$props2.hideLegend,
          chartWrapperProps = _this$props2.chartWrapperProps,
          pattern = _this$props2.pattern,
          rest = _objectWithoutProperties(_this$props2, ["series", "hideLegend", "chartWrapperProps", "pattern"]);

      return /*#__PURE__*/React.createElement(Wrapper, rest, renderIf(!hideLegend, function () {
        return /*#__PURE__*/React.createElement(Legend, {
          series: series,
          getLabel: function getLabel(s) {
            return "".concat(Math.round(s.value), "% ").concat(s.label);
          }
        });
      }), /*#__PURE__*/React.createElement(ReactResizeDetector, {
        handleWidth: true
      }, function (dimensions) {
        return /*#__PURE__*/React.createElement(ChartWrapper, chartWrapperProps, /*#__PURE__*/React.createElement(StackedBarChart, Object.assign({
          getId: function getId(s) {
            return s.label;
          },
          pattern: pattern,
          series: series
        }, dimensions)));
      }), this.description);
    }
  }]);

  return StackedBarChartWithLegend;
}(React.PureComponent);

_defineProperty(StackedBarChartWithLegend, "propTypes", {
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  series: stackedBarChartSeriesPropType.isRequired,
  hideLegend: PropTypes.bool,
  chartWrapperProps: PropTypes.object,
  descriptionProps: PropTypes.object,
  pattern: componentPropType
});

_defineProperty(StackedBarChartWithLegend, "defaultProps", {
  hideLegend: false,
  chartWrapperProps: {},
  descriptionProps: {}
});

export default StackedBarChartWithLegend;